export const initialValues = {
  applicantInformation: {
    fullName: '',
    contactEmail: '',
  },
  projectDetails: {
    streetAddress: '',
    city: 'Birmingham',
    state: 'Alabama',
    zipCode: '',
    neighborhood: '',
    projectType: '',
    noOfCommercial: '',
    proposedUnits: '',
    projectByRight: '',
    constructionType: '',
    // proposedPurchasePrice: '',
    developmentCostEstimate: '',
    siteControlStatus: '',
    acquisitionType: '',
    haveCommunitySupport: '',
    isPropertyCityOwn: '',
    proposedAmount: '',
    familyType: '',
    rentType: {
      studios: '',
      oneBedroom: '',
      twoBedrooms: '',
      threeBedrooms: '',
    },
    avgSalesPrice: '',
    moreInfo: '',
    additionalDocs: [],
  },
  developmentTeam: [],
  developmentSchedule: {
    schedule1: { startDate: '', finishDate: '' },
    schedule2: { startDate: '', finishDate: '' },
    schedule3: { startDate: '', finishDate: '' },
    schedule4: { startDate: '', finishDate: '' },
    schedule5: { startDate: '', finishDate: '' },
  },
  projectFinance: {
    sources: [
      { name: 'City of Birmingham', amount: 0 },
      { name: 'Developer Equity', amount: 0 },
    ],
    uses: {
      acquisition: '',
      hardCost: '',
      softCost: '',
      financeCost: '',
      developerFeeAmount: '',
    },
    financeDocs: [],
    willUseHomeFunds: '',
    willUseCDBGFunds: '',
  },
  applicantInfo: {
    entityName: '',
    contactPersonName: '',
    contactPersonEmail: '',
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    phone: '',
    website: '',
    formationDate: '',
    fullTimeEmployeeCount: '',
    anyApply: [],
  },
  leadershipInformation: {
    racialEthnicGroup: [],
    hasMajorityOwnership: '',
    majorityOwnership: [],
    boardOfDirectorsPercent: {
      communityMembersPercent: '',
      hispanicLatinxPercent: '',
      blackAfricanAmericanPercent: '',
      asianPacificIslandersPercent: '',
      nativeAmericanPercent: '',
      whiteCaucasianPercent: '',
      multiRacialPercent: '',
    },
    principalsResume: [],
  },
  experience: {
    companyCompleted: [],
    principalCompleted: [],
  },
};
